export default __webpack_public_path__ + "static/media/course5.a9a863ad.png";